<template>
  <div class="container-fluid p-3">
    <div class="row">
      <div class="col-12 col-md-4">
        <div class="card">
          <div class="card-header">
            <h5>MANIFIESTO</h5>
          </div> 
          <div class="card-body">
            <div class="alert alert-light">
              <i class="fa fa-exclamation"></i> Realice los siguientes pasos para el registro masivo a través de la plantilla Excel. <a class="btn-link" @click="onPopupAyuda" >Ver ejemplo de plantilla Excel.</a>
            </div>
            <hr>
            <h6>PASO 1: <small><b>DESCARGAR ARCHIVO EXCEL</b></small></h6>
            <div class="row">
              <div class="col-md-12 text-center mt-2">
                <button type="button" class="btn btn-outline-success" @click="downloadPlantilla">
                  <i class="fa fa-download"></i> Descargar Plantilla
                </button>
              </div>
            </div> <br>
            <div class="alert alert-warning" role="alert" style="background-color:#F96540;color:#000;">
              <i class="fa fa-exclamation-triangle"></i> <b>Atención</b><br> 
              Formato oficial del Excel<br><b>Solo utilizar la plantilla de descarga.</b>
            </div>
            <hr>
            <h6>PASO 2: <small><b>SUBIR ARCHIVO EXCEL</b></small></h6>
            <div class="row pt-3">
              
                  <div class="col-lg-12 ">
                    <label class="mr-1">Cargar archivo:</label><br>  
                    <input 
                      type="file" 
                      id="file" 
                      ref="file" 
                      class="form-control" 
                      accept=".xls,.xlsx"
                      @change="actualizaExcel($event)" 
                    >
                  </div>
                  <div class="col-lg-12 ">
                    <div class="form-group">
                      <label>Tipo Vuelo:</label><br>  
                      <select 
                        class="form-control"
                        v-model="tipo_vuelo"
                      >
                        <option value="" selected>SELECCIONAR</option>
                        <option value="I">INGRESO</option>
                        <option value="S">SALIDA</option>
                      </select>
                    </div>
                    <div class="form-group">
                      <label>Nro. Vuelo:</label><br>  
                      <input 
                        type="text" 
                        class="form-control" 
                        placeholder="Ej. LA-235, LA 235, 235"
                        v-model="nro_vuelo"
                        @keyup="nro_vuelo = nro_vuelo.toUpperCase()"
                      >
                    </div>
                  </div>
                
            </div>
            <hr>
            <div class="row">
              <div class="col-12 col-md-12 text-right">
                <button type="button" class="btn btn-primary" @click="procesarArchivo">Registrar Manifiesto</button>
              </div>
            </div>
          </div>
            
        </div>
      </div>
      <div class="col-12 col-md-8">
        <div class="card">      
          <div class="card-header">
            <h5>{{'EMPRESA - ' + empresa.emp_razon_social}}</h5>
          </div>        
          <div class="card-body">
            <div class="alert alert-warning" role="alert" style="background-color: rgba(248, 214, 43, 0.3);color:#000;">
              <i class="fa fa-exclamation-triangle"></i> <b>Atención</b><br> 
              Debe finalizar los partes declarados, si los datos cargados son correctos.<br>
              Parte en estado <b>pendiente</b> tiene hasta 48 hrs para realizar el <b>alta</b> o <b>baja</b>, después de la fecha de registro. Una vez vencido no se tomar en cuenta como una declaración formal.
            </div>
            <p><small><strong>HISTORIAL DE MANIFIESTO</strong></small></p>
            <div class="table-responsive" style="overflow-y:scroll; height:360px;">
              <table class="table table-striped table-bordered">
                <thead>
                  <tr>
                    <th class="text-center"><small class="font-weight-bold">NRO</small></th>
                    <th class="text-center"><small class="font-weight-bold">FECHA REGISTRO</small></th>
                    <th class="text-center"><small class="font-weight-bold">TIPO VUELO</small></th>
                    <th class="text-center"><small class="font-weight-bold">NRO VUELO</small></th>
                    <th class="text-center"><small class="font-weight-bold">ESTADO</small></th>
                    <th class="text-center"><small class="font-weight-bold">ACCIONES</small></th>
                  </tr>                        
                </thead>
                <tbody>
                  <tr v-for="(item, index) in historial" :key="index">
                    <td class="text-center"><small>{{index+1}}</small></td>
                    <td class="text-center"><small>{{item.fecha_reg}}</small></td>
                    <td class="text-center"><small>{{item.tipo_vuelo}}</small></td>
                    <td class="text-center"><small>{{item.nro_vuelo}}</small></td>
                    <td class="text-center">
                      <span v-if="item.estado_proceso == 0 && item.verifica_estado == 1" class="badge badge-warning">PENDIENTE</span>
                      <span v-if="item.estado_proceso == 0 && item.verifica_estado == 0" class="badge badge-danger">VENCIDO</span>
                      <span v-if="item.estado_proceso == 1" class="badge badge-success"> FINALIZADO</span>
                    </td>
                    <td class="text-center">
                      <a 
                        v-if="item.estado_proceso == 0 && item.verifica_estado == 1" 
                        class="btn btn-outline-success btn-sm mr-1" 
                        title="Alta de Parte"
                        @click="showModalConfirmar(item)"
                      >
                        <i class="fa fa-check"></i>
                      </a>
                      <a 
                      v-if=" item.verifica_estado == 1" 
                        class="btn btn-outline-primary btn-sm mr-1" 
                        title="Ver Parte"
                        @click="showModal(item)"
                      >
                        <i class="fa fa-search"></i>
                      </a>
                      <a 
                        v-if="item.estado_proceso == 0 && item.verifica_estado == 1" 
                        class="btn btn-outline-danger btn-sm" 
                        title="Baja de Manifiesto"
                        @click="bajaParte(item.id_aereo)"
                      >
                        <i class="fa fa-close"></i>
                      </a>
                    </td>
                  </tr>
                </tbody>
                
              </table>
            </div>  
          </div>                
        </div>
      </div>
    </div>
      
    <b-modal
      class="modal fade"
      size="xl"
      hide-footer
      title="DETALLE DE MANIFIESTO"
      ref="modalDetalles"
      :no-close-on-backdrop="true"
    >
      <div class="container mb-3">
        <div class="row mb-1">   
          <p>Detalle de parte registrado en: {{ elegido.fecha_reg }}.</p>
          <div class="table-responsive" style="overflow-y:scroll; height:360px;" v-if="detalles.length>0">
            <table class="table table-striped table-bordered">
              <thead>
                  <tr class="text-center">
                    <th><small class="font-weight-bold">NRO</small></th>
                    <th><small class="font-weight-bold">NOMBRE COMPLETO</small></th>
                    <th><small class="font-weight-bold">NRO. DOCUMENTO</small></th>
                    <th><small class="font-weight-bold">NACIONALIDAD</small></th>
                    <th><small class="font-weight-bold">ORIGEN/DESTINO</small></th>
                    <th><small class="font-weight-bold">ACCIÓN</small></th>
                  </tr>                        
              </thead>
              <tbody>
                <tr v-for="(item, index) in detalles" :key="index">
                  <td class="text-center"><small>{{index+1}}</small></td>
                  <td><small>{{item.nombre_completo}}</small></td>
                  <td class="text-center"><small>{{item.nro_documento}}</small></td>
                  <td class="text-center"><small>{{item.nacionalidad}}</small></td>                     
                  <td class="text-center"><small>{{item.origen+'/'+item.destino}}</small></td> 
                  <td class="text-center" >
                    <a 
                     v-if="elegido.estado_proceso == 0 && elegido.verifica_estado == 1" 
                      class="btn btn-outline-danger btn-sm" 
                      title="Dar de baja"
                      @click="showModalConfirmarBaja(item)"
                    >
                      <i class="fa fa-close"></i>
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>              
        </div>
        <div class="row float-right">
          <a class="btn btn-outline-secondary" @click="hideModal">Cerrar</a>
        </div>
      </div>
    </b-modal>
    
    <b-modal
      class="modal fade"
      hide-footer
      title="CONFIRMAR"
      ref="modalConfirmarBaja"
      :no-close-on-backdrop="true"
    >
      <div class="container mb-3">
        <div class="row mb-1">   
          <p>¿Porqué motivo se quiere dar de baja al registro?</p> 
          <p>Tome en cuenta que <strong>el manifiesto finalizado</strong> no se pueden modificar ni borrar.</p>                          
        </div>
        <div class="form-group">
          <label>Descripción</label><br> 
          <input 
            type="text" 
            class="form-control" 
            placeholder="EJ. EL PASAJERO TUVO PROBLEMAS CON CONTROL DE ADUANAS"
            v-model="descripcion_baja" required
            @keyup="descripcion_baja = descripcion_baja.toUpperCase()"
          >
        </div>
        <div class="row float-right">
          <a class="btn btn-outline-primary mr-3" @click="confirmar_baja(itemElegido.id_detalle,descripcion_baja)"><i class="fa fa-check"></i> Confirmar</a>
          <a class="btn btn-outline-secondary" @click="showModalConfirmarEliminacion">Cerrar</a>
        </div>
      </div>
    </b-modal>

    <b-modal
      class="modal fade"
      hide-footer
      title="CONFIRMAR"
      ref="modalConfirmar"
      :no-close-on-backdrop="true"
    >
      <div class="container mb-3">
        <div class="row mb-1">   
          <p>¿Desea confirmar y finalizar el manifiesto declarado?</p> 
          <p>Tome en cuenta que <strong>el manifiesto finalizado</strong> no se pueden modificar ni borrar.</p>                          
        </div>
        <div class="row float-right">
          <a class="btn btn-outline-primary mr-3" @click="confirmar(elegido)"><i class="fa fa-check"></i> Confirmar</a>
          <a class="btn btn-outline-secondary" @click="hideModalConfirmar">Cerrar</a>
        </div>
      </div>
    </b-modal>

    <b-modal
      class="modal fade"
      hide-footer
      title="EJEMPLO DE PLANTILLA EXCEL"
      ref="modalAyuda"
      size="xl"
      :no-close-on-backdrop="true"
    >
      <div class="container mb-3">
        <div class="row">   
          <div class="col-12 col-md-12">
            <img src="../../assets/plantilla.png" width="100%">
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-12 col-md-12">
            <p>Forma correcta de llenado de datos de la plantilla Excel:<br />
              - Mantener las cabeceras de cada columna.<br/>
              - Llenar los campos correspondiente a cada cabecera.
            </p>
          </div>
        </div>
        
      </div>
    </b-modal>
  </div>
</template>

<script>
import moment from "moment";
import FileSaver from 'file-saver';

export default {
  name: "partesAereo",
  data() {
    return {
      id_empresa : 0,
      tipo_vuelo: '',
      nro_vuelo: '',
      historial: [],
      detalles: [],
      descripcion_baja: '',
      elegido: {},
      itemElegido: {},
      empresa: {},
      fechaMin: new moment().format("YYYY-MM-DD"),
    };
  },
  methods: {
    getDate: function(fecha) {
      return moment(fecha).format("DD/MM/YYYY");
    },
    showModal(item) {
      this.elegido = item;
      this.detallePartes(item.id_aereo);
      this.$refs["modalDetalles"].show();
    },
    hideModal() {
      this.elegido = {};
      this.$refs["modalDetalles"].hide();
    },
    showModalConfirmar(item) {
      this.elegido = item;
      this.$refs["modalConfirmar"].show();
    },
    hideModalConfirmar() {
      this.elegido = {};
      this.$refs["modalConfirmar"].hide();
    },
    showModalConfirmarBaja(item) {
      this.itemElegido = item;
      this.$refs["modalConfirmarBaja"].show();  
    },
    showModalConfirmarEliminacion() {
      this.itemElegido = {};
      this.$refs["modalConfirmarBaja"].hide();
    },
    actualizaExcel(){
      this.file = this.$refs.file.files[0];
    },
    async procesarArchivo() {
      if(this.file == undefined){
        this.$swal({
          title: 'Atención',
          text: 'Debe cargar el parte (plantilla excel).',
          type: 'warning',
          confirmButtonText: 'Aceptar'
        });
        return;
      }
      else{
        let fileName = this.file.name;
        var ext = fileName.split('.').pop();

        ext = ext.toLowerCase();
        if(ext != "xls" && ext != "xlsx"){
          this.$swal({
            title: 'Atención',
            text: 'Debe cargar el parte (plantilla excel).',
            type: 'warning',
            confirmButtonText: 'Aceptar'
          });
          return;
        }
      }

      if(this.tipo_vuelo == ''){
        this.$swal({
          title: 'Atención',
          text: 'Seleccionar tipo de vuelo.',
          type: 'error',
          confirmButtonText: 'Aceptar'
        });
        return;
      }

      if(this.nro_vuelo == ''){
        this.$swal({
          title: 'Atención',
          text: 'Ingresar número de vuelo.',
          type: 'error',
          confirmButtonText: 'Aceptar'
        });
        return;
      }

      let config = {        
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
      let formData = new FormData();
      formData.append('id_empresa', this.id_empresa);
      formData.append('archivo', this.file);
      formData.append('nro_vuelo', this.nro_vuelo);
      formData.append('tipo_vuelo', this.tipo_vuelo);
      try {

        let res = await this.axios.post(`/subir/partes_aereos`, formData, config);
        if (res.status === 200) {
          this.cargarHistorial(this.id_empresa);
          this.$swal({
            title: 'Información',
            text: 'Se subió correctamente el archivo',
            type: 'success',
            confirmButtonText: 'Aceptar'
          });
          this.Limpiar();
        }
      } catch (error) {
        console.log('catch: ', error);
        this.cargando = false;
      }
    },
    async cargarHistorial(id_empresa) {
      this.cargando = true;
      try {
        let res = await this.axios.get(`/historial/partesAereo/${id_empresa}`);
        this.historial = res.data.contenido;
        this.cargando = false;
      } catch (error) {
        console.log('error ', error);
        this.cargando = false;
      }      
    },
    async detallePartes(id_aereo) {
      this.cargando = true;
      try {
        let res = await this.axios.get(`/historial/detalleAereo/${id_aereo}`);
        this.detalles = res.data.contenido;
        this.cargando = false;
      } catch (error) {
        console.log('error ', error);
        this.cargando = false;
      }      
    },
    async confirmar(item) {
      this.cargando = true;
      try {
        let res = await this.axios.put(`/confirmarParteAereo/${item.id_aereo}`);
        if (res.status === 200) {
          this.cargando = false;
          this.cargarHistorial(this.id_empresa);
          this.hideModalConfirmar();
          this.$swal({
            title: 'Información',
            text: 'Finalizó correctamente el registro',
            type: 'success',
            confirmButtonText: 'Aceptar'
          });
        }
        
      } catch (error) {
        console.log('error ', error);
        this.cargando = false;
      }      
    },
    async confirmar_baja(id_detalle,detalle_baja) {
     // console.log(id_detalle);
      if(this.descripcion_baja == ''){
          this.$swal({
            title: 'Atención',
            text: 'La descripcion es obligatoria',
            type: 'error',
            confirmButtonText: 'Aceptar'
          });
          return;
      }
      this.cargando = true;
      try {
        let data = {
          id_detalle: id_detalle,
          descripcion_baja: detalle_baja
        };
        let res = await this.axios.put(`/confirmarBajaParteAereo`, data);
        if (res.status === 200) {
          this.detallePartes( this.elegido.id_aereo);
          this.descripcion_baja = '';
          this.$refs["modalConfirmarBaja"].hide();
          this.cargando = false;
          this.$swal({
            title: 'Información',
            text: 'Se dio de baja exitosamente',
            type: 'success',
            confirmButtonText: 'Aceptar'
          });   
        }  
      } catch (error) {
        console.log('error ', error);
        this.cargando = false;
      }      
    },
    async downloadPlantilla(){
     try {
        let resultados = await this.axios.get('/getPlantilla', {responseType: 'blob'});
        //console.log(resultados);
        if(resultados.status == 200){
          let file = new Blob([resultados.data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'})
          FileSaver.saveAs(file, 'plantilla.xlsx');
        }
      } catch (error) {
        console.log('catch: ', error);
      }

    },
    onChangeFechaIni(event){
      let fecha = event.target._value;
      document.getElementById("fecha_fin").setAttribute("min",fecha);
    },
    onPopupAyuda(){
      this.$refs["modalAyuda"].show();
    },
    bajaParte(id_aereo){
      try {
        this.$swal({
          text: '¿Confirma quitar declaración de manifiesto?',
          type: 'warning',
          cancelButtonText: 'Cancelar',
          confirmButtonText: 'Aceptar',
          showCancelButton: true,
          showCloseButton: true,
          showLoaderOnConfirm: true
        })
        .then((result)=>{
          if(result.value){
            this.axios.put(`/bajaParteAereo/${id_aereo}`)
            .then(()=>{
              this.cargarHistorial(this.empresa.id_empresa);
            });
          }
        });
      } catch (error) {
        console.log('catch: ', error);
      }
    },
    Limpiar(){
      this.file = '';
      this.nro_vuelo = '';
      this.tipo_vuelo = '';
    },
    
  },
  created(){
    //if(this.$route.params.id_empresa===undefined){
    if(this.$route.params.item===undefined){
      this.$router.push('Empresas');
    }else{
      //this.id_empresa = this.$route.params.id_empresa;
      this.empresa = this.$route.params.item;
      this.id_empresa = this.$route.params.item.id_empresa;
      this.cargarHistorial(this.empresa.id_empresa);
    }   

  }

};
</script>